/**
 * pixi-particles — ParticleProcessor.ts
 * Ported from Phaser.GameObjects.Particles.ParticleProcessor
 *
 * Base class for anything that nudges particle velocity/position each frame
 * (GravityWell, ParticleBounds, or your own custom processor). Extend it and
 * override `update`.
 */
import { AnyParticle } from './EmitterOp';

export class ParticleProcessor
{
    emitter: any = null;
    x: number;
    y: number;
    active: boolean;

    constructor (x = 0, y = 0, active = true)
    {
        this.x = x;
        this.y = y;
        this.active = active;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update (_particle: AnyParticle, _delta: number, _step?: number, _t?: number): void
    {
    }

    destroy (): void
    {
        this.emitter = null;
    }
}

export default ParticleProcessor;
